<template>
  <page-article
    :page-title="currentJobDetailsGetter.job_title"
    :attachments="currentJobDetailsGetter.job_attachments"
  >
    <template slot="meta">
      <div class="col-5">
        <div class="row">
          <div class="col-4">
            <font-awesome-icon icon="calendar-alt" />
            {{ currentJobDetailsGetter.job_published_at || new Date() | moment("YYYY/MM/DD") }}
          </div>
        </div>
      </div>
    </template>
    <template>
      <div class="page_article_block col-12">
        <ul class="article_info_list">
          <li class="article_info_item">
            <span class="article_tag">公司名稱</span>
            <router-link :to="`/job-opening/zh/${currentJobDetailsGetter.job_id}/enterprise`">
              {{ currentJobEnterpriseGetter.enterprise_name }}
            </router-link>
          </li>
          <li class="article_info_item">
            <span class="article_tag">截止日期</span>{{ currentJobDetailsGetter.job_publishing_deadline || new Date() | moment("YYYY/MM/DD") }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">職務類別</span>
            <span
              v-for="(identity, index) in currentJobDetailsGetter.job_identity"
              :key="index"
            >
              {{ identity }}
            </span>
          </li>
          <li class="article_info_item">
            <span class="article_tag">產業類別</span>{{ currentJobDetailsGetter.job_industry }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">工作年資</span>{{ yearsOfExperience[currentJobDetailsGetter.job_years_experience] }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">科系需求</span>{{ currentJobDetailsGetter.job_departments }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">工作地點</span>{{ currentJobDetailsGetter.job_location }}
          </li>

          <li class="article_info_item">
            <span class="article_tag">職務內容</span>
          </li>
        </ul>
        <div
          class="article_content"
          v-html="currentJobDetailsGetter.job_content"
        />
        <div class="article_info_item">
          <span class="article_tag">其他條件</span>
        </div>
        <div
          class="article_content"
          v-html="currentJobDetailsGetter.job_miscellaneous"
        />
        <div class="article_info_item">
          <span class="article_tag">聯絡人</span>{{ currentJobDetailsGetter.job_contact_person }}
        </div>
        <div class="article_info_item">
          <span class="article_tag">聯絡電話</span>{{ currentJobDetailsGetter.job_tel }}
        </div>
        <div class="article_info_item">
          <span class="article_tag">電子信箱</span>{{ currentJobDetailsGetter.job_email }}
        </div>
      </div>
    </template>
  </page-article>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import pageArticle from '~components/pages/Article'
export default {
  name: 'JobOpeningZhDetailsContent',
  components: {
    pageArticle
  },
  data () {
    return {
      yearsOfExperience: [
        '不限制', '1年以下', '1-3年', '3-5年', '5年以上'
      ]
    }
  },
  computed: {
    ...mapGetters('pages/jobs', [
      'currentJobDetailsGetter',
      'currentJobEnterpriseGetter'
    ])
  },
  async created () {
	try {
		await this.getJobDetailsById(this.$route.params.id)
	} catch (err) {
		this.$router.push('/job-opening/zh');
	}
  },
  methods: {
    ...mapActions('pages/jobs', [
      'getJobDetailsById'
    ])
  }
}
</script>
